@charset "UTF-8";

/* src/app/global/components/global-settings-changepassword/global-settings-changepassword.component.scss */
.cw-password-field {
  display: flex;
  align-items: center;
}
.cw-password-field .cw-login-input {
  flex: 1;
  width: auto;
}
.cw-password-toggle {
  flex-shrink: 0;
  width: 35px;
  height: 35px;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--color-primary-lighter);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cw-password-toggle:hover {
  color: var(--color-primary);
  background-color: rgba(0, 0, 0, 0.04);
  border-radius: 50%;
}
.cw-login-input {
  margin-bottom: 10px;
  width: 100%;
}
.cw-login-input:focus {
  border-color: var(--color-primary);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px rgba(144, 144, 144, 0.4);
  outline: none;
}
:host .cw-login-error + .cw-button-wrapper {
  justify-content: center;
}
h3 {
  margin-bottom: 10px;
}
/*# sourceMappingURL=global-settings-changepassword.component.css.map */
